import styled, { keyframes } from 'styled-components';

import breakpoints from '../../util/breakpoints';

const FLOAT_DISTANCE = '20px';

const floatOffset = keyframes`
  0% {
    transform: translateY(${FLOAT_DISTANCE});
  }
  50% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(${FLOAT_DISTANCE});
  }
`;

const float = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(${FLOAT_DISTANCE});
  }
  100% {
    transform: translateY(0px);
  }
`;

const Person = styled.img`
  position: absolute;
  will-change: transform;
`;

export const Katy = styled(Person)`
  width: 235px;
  top: 60px;
  left: 20px;

  animation: ${floatOffset} 11s ease-in-out infinite;

  ${breakpoints.md`
    top: 120px;
    left: 50px;
  `}

  ${breakpoints.lg`
    width: 360px;
  `}

  ${breakpoints.xl`
    width: 450px;
  `}
`;

export const Nico = styled(Person)`
  width: 250px;
  top: 200px;
  right: 20px;

  animation: ${float} 8s ease-in-out infinite;

  ${breakpoints.sm`
    top: 100px;
  `}

  ${breakpoints.md`
    top: 120px;
    right: 50px;
  `}

  ${breakpoints.lg`
    width: 400px;
  `}

  ${breakpoints.xl`
    width: 475px;
  `}
`;

export default Person;



// WEBPACK FOOTER //
// ./src/components/ui/Person.js